import { Container } from "react-bootstrap";
import { HashRouter as Router, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomeScreen from "./screens/HomeScreen";
import ProductScreen from "./screens/ProductScreen";
import CartScreen from "./screens/CartScreen";
import LoginScreen from "./screens/LoginScreen";
import TermsScreen from "./screens/TermsScreen";
import ProfileScreen from "./screens/ProfileScreen";
import AdjustmentsScreen from "./screens/AdjustmentsScreen";
import ConfigureScreen from "./screens/ConfigureScreen";
import ClientInfoScreen from "./screens/ClientInfoScreen";
import PlaceQuoteScreen from "./screens/PlaceQuoteScreen";
import GuestScreen from "./screens/GuestScreen";
import OrderScreen from "./screens/OrderScreen";
import UserListScreen from "./screens/UserListScreen";
import UserEditScreen from "./screens/UserEditScreen";
import ProductListScreen from "./screens/ProductListScreen";
import ProductEditScreen from "./screens/ProductEditScreen";
import OrderListScreen from "./screens/OrderListScreen";

function App() {
  const userLogin = useSelector(state => state.userLogin);
  const { userInfo } = userLogin;

  return (
    <Router>
      <Header />
      <main className="py-3">
        <Container>
          <Route path="/" component={HomeScreen} exact />
          <Route path="/login" component={LoginScreen} />
          <Route path="/terms-and-conditions" component={TermsScreen} />
          <Route path="/profile" render={(props) => (
            userInfo ? <ProfileScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/guest" component={GuestScreen} />
          <Route path="/adjustments" render={(props) => (
            userInfo ? <AdjustmentsScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/configure" render={(props) => (
            userInfo ? <ConfigureScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/clientinfo" render={(props) => (
            userInfo ? <ClientInfoScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/placequote" render={(props) => (
            userInfo ? <PlaceQuoteScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/order/:id" render={(props) => (
            userInfo ? <OrderScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/product/:id" component={ProductScreen} />
          <Route path="/cart/:id?" component={CartScreen} />
          <Route path="/admin/userlist" render={(props) => (
            userInfo ? <UserListScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/admin/user/:id/edit" render={(props) => (
            userInfo ? <UserEditScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/admin/productlist" render={(props) => (
            userInfo ? <ProductListScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/admin/product/:id/edit" render={(props) => (
            userInfo ? <ProductEditScreen {...props} /> : <Redirect to='/login' />
          )} />
          <Route path="/admin/orderlist" render={(props) => (
            userInfo ? <OrderListScreen {...props} /> : <Redirect to='/login' />
          )} />
        </Container>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
